import { useCallback, useState } from "react";

/**
 * Single source of truth for which process row is being edited and which is
 * expanded. Both are plain local UI state — they are deliberately NOT written
 * back into the API record array, so the records stay clean of UI flags.
 */
export const useProcessRowEditing = () => {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const isEditing = useCallback((id: string) => editingId === id, [editingId]);
  const isExpanded = useCallback((id: string) => expandedId === id, [expandedId]);

  const startEdit = useCallback((id: string) => setEditingId(id), []);
  const cancelEdit = useCallback(() => setEditingId(null), []);
  /** Called after a successful save — leaves edit mode without discarding anything. */
  const finishEdit = useCallback(() => setEditingId(null), []);

  const toggleExpand = useCallback(
    (id: string) => setExpandedId(current => (current === id ? null : id)),
    []
  );

  return { editingId, expandedId, isEditing, isExpanded, startEdit, cancelEdit, finishEdit, toggleExpand };
};
